import type { WordpressPage } from '@benzinga/content-manager';
import { SCREENER_VARIANTS } from '../../../../screener-configs/shared-screener-config';

export const RANKING_HEADER_BLOCK_NAME = 'acf/money-layout-header';

const RANKING_TAB_ORDER = Object.keys(SCREENER_VARIANTS);
const RANKING_SLUG_PATTERN = /^\/screener\/(?:best|top)-([a-z]+)-stocks$/;

function rankingTabRank(href: string): number {
  const variant = RANKING_SLUG_PATTERN.exec(href)?.[1];
  const index = variant ? RANKING_TAB_ORDER.indexOf(variant) : -1;
  return index === -1 ? RANKING_TAB_ORDER.length : index;
}

export function isRankingVariantHref(href: string): boolean {
  return RANKING_SLUG_PATTERN.test(href);
}

export function sortRankingTabs<T extends { href: string }>(tabs: T[]): T[] {
  return [...tabs].sort((a, b) => rankingTabRank(a.href) - rankingTabRank(b.href));
}

export interface RankingHeaderConfig {
  description?: string;
  services: { title: string; url: string }[];
  subtitle?: string;
  title: string;
}

export function findRankingHeaderBlock(post: WordpressPage) {
  return post.header?.blocks?.find(block => block.blockName === RANKING_HEADER_BLOCK_NAME);
}

export function getRankingHeaderConfig(post: WordpressPage): RankingHeaderConfig | null {
  const data = findRankingHeaderBlock(post)?.attrs?.data;
  if (typeof data?.title !== 'string') return null;

  const services = Array.isArray(data.services)
    ? data.services.filter(
        (service: { title?: unknown; url?: unknown }) =>
          typeof service?.title === 'string' && typeof service?.url === 'string',
      )
    : [];

  return {
    description: typeof data.description === 'string' ? data.description : undefined,
    services,
    subtitle: typeof data.subtitle === 'string' ? data.subtitle : undefined,
    title: data.title,
  };
}
